import { useEffect, useState } from 'react';
import { finishesAtOnce, finishNotice } from '../domain/countdown';

/**
 * The notices around finishing an exercise, shared by web and mobile: "You did it!" once
 * the countdown reaches zero, "Don't leave yet" when Done is pressed with time left. Either
 * one offers "Mark complete", which runs `finish` (the screen's own Done), and "Keep going",
 * which closes it. After "Keep going" at zero the clock rests there and Done finishes at
 * once; a reset starts a new countdown, whose end is told again. Nothing stops on its own
 * when the time is up: the person decides.
 */
export function useFinishNotice(secondsLeftNow: number, finish: () => void) {
  const [timeUpAnswered, setTimeUpAnswered] = useState(false);
  const [doneEarly, setDoneEarly] = useState(false);
  const ended = finishesAtOnce(secondsLeftNow);
  useEffect(() => {
    if (!ended) setTimeUpAnswered(false);
  }, [ended]);
  const answered = () => {
    if (ended) setTimeUpAnswered(true);
    setDoneEarly(false);
  };
  return {
    /** Which notice is up, if any. */
    shown: finishNotice(secondsLeftNow, { timeUpAnswered, doneEarly }),
    /** The screen's Done button: finishes now when the time is up, asks first otherwise. */
    done: () => {
      if (ended) finish();
      else setDoneEarly(true);
    },
    keepGoing: answered,
    markComplete: () => {
      answered();
      finish();
    },
  };
}
